import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import Head from 'next/head';
import { jsonLdScriptProps } from 'react-schemaorg';

import Link from '../Link/Link';
import ArrowRightIcon from '../icons/ArrowRightIcon';
import Container from '../Container/Container';

const rootCss = css`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 33px;
  font-weight: 500;
`;

const linkItemCss = css`
  display: inline-flex;
  align-items: center;
  line-height: 1.5;
`;

const arrowDividerCss = css`
  margin: 0 2px;
`;
function PostBreadcrumbs({ breadcrumbs }) {
  const crumbs = [
    {
      linkHref: '/info-center',
      linkAs: '/info-center',
      slug: 'main',
      title: 'Main',
    },
    ...breadcrumbs,
  ];

  // Add breadcrumb trails
  // https://developers.google.com/search/docs/data-types/breadcrumb
  const structuredDataItems = crumbs.map(({ linkAs, title }, i) => ({
    '@type': 'ListItem',
    item: `${process.env.BRAND_DOMAIN}${linkAs}`,
    name: title,
    position: i + 1,
  }));

  return (
    <>
      <Head>
        <script
          {...jsonLdScriptProps({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: structuredDataItems,
          })}
        />
      </Head>
      <Container>
        <nav aria-label="breadcrumbs" css={rootCss}>
          <ol>
            {crumbs.map((page, i) => {
              const isLast = i === crumbs.length - 1;

              return (
                <li css={linkItemCss} key={page.slug}>
                  {page.linkHref ? (
                    <Link
                      href={page.linkHref}
                      as={page.linkAs}
                      aria-current={isLast ? 'location' : undefined}
                    >
                      {page.title}
                    </Link>
                  ) : (
                    page.title
                  )}

                  {!isLast && <ArrowRightIcon css={arrowDividerCss} />}
                </li>
              );
            })}
          </ol>
        </nav>
      </Container>
    </>
  );
}

PostBreadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      linkHref: PropTypes.string,
      linkAs: PropTypes.string,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
};

export default PostBreadcrumbs;
